export const notifications = {
	export: {
		successNotification: "Produits exportés vers Excel",
		errorNotification: "Erreur lors de l'exportation des produits vers Excel",
	},
	productToggle: {
		successActivated: "Le produit {{productName}} a été activé avec succès",
		successDeactivated: "Le produit {{productName}} a été désactivé avec succès",
	},
	massActions: {
		successActivated: "Produits activés avec succès",
		successDeactivated: "Produits désactivés avec succès",
	},
	categoryNotFound:
		"Catégorie introuvable. Redirection vers la première catégorie disponible.",
};
